module.exports = __webpack_public_path__ + "static/img/ent-detail-3.a128ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-3.jpg
// module id = Nl0h
// module chunks = 51